console.log('starting gems online examiner app...');
require ('./app/common');
require ('./app/online-global');
require ('./app/online-admin');



